import React, { Component } from 'react';
import { FormControl} from 'react-bootstrap';


class GCLimitNotes extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            value: props.submission && props.submission.onGCLimitNotes ? props.submission.onGCLimitNotes : ''
        };
    }

    handleChange(evt) {
        const val = evt.target.value;
        this.setState({
            ...this.state,
            value: val
        }, () => {this.props.onGCLimitNotes(this.state.value)})
    }

    render() { 
        
            return (<div className="GCLimitNotesContainer">
            <h4 className="quoteTitle">Underwriter Notes (mandatory if GC Required Limits are changed)</h4>
            <FormControl
                autoComplete={false}
                type={'text'}
                onChange={this.handleChange}
                componentClass={'textarea'}
                value={this.state.value}
                defaultValue={this.state.value}
                placeholder='Optional'
            />
        </div>
            );
    }
}

export default GCLimitNotes;